<template>
  <div class="pt-3">
    <div class="d-flex justify-space-between mb-5">
      <title-page title="List of Contact Person" />
      <div v-if="permissions.includes('UPCM') || role == 'SUPERADMIN'">
        <v-btn
          depressed
          @click="createData"
          color="var(--g)"
          dark
          class="text-capitalize mr-2"
          >+ New</v-btn
        >
      </div>
    </div>
    <v-row>
      <v-col cols="12">
        <div class="d-flex align-center ml-2">
          <v-icon class="magnify">mdi-magnify</v-icon>
          <input
            type="text"
            v-model="find"
            @keydown="fetchData"
            placeholder="Search"
            class="input_green"
          />
        </div>
      </v-col>
    </v-row>
    <!--  ========================================================================= data table -->
    <div class="mt-5 py-3">
      <v-skeleton-loader type="table-tbody" v-if="loading"></v-skeleton-loader>
      <div v-if="dataSet && !loading">
        <v-data-table
          :headers="headers"
          :items="dataSet"
          :page.sync="page"
          :items-per-page="limit"
          class="elevation-0 color_txt"
          hide-default-footer
        >
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex">
              <v-btn
                :disabled="
                  permissions.includes('UPCM') || role == 'SUPERADMIN'
                    ? false
                    : true
                "
                icon
                class="text-capitalize mr-2"
                @click="updateData(item)"
              >
                <v-icon dark small> mdi-pencil </v-icon>
              </v-btn>
              <v-btn
                :disabled="
                  permissions.includes('UPCM') || role == 'SUPERADMIN'
                    ? false
                    : true
                "
                icon
                class="text-capitalize"
                @click="deleteData(item)"
              >
                <v-icon dark small> mdi-trash-can </v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
        <div class="py-3" v-if="dataSet">
          <v-row>
            <v-col cols="12" md="6">
              <div class="d-flex align-center">
                <p class="mr-2 mb-0">ROWS PER PAGE</p>
                <div style="width: 100px">
                  <v-select
                    dense
                    hide-details
                    :items="rows"
                    item-text="txt"
                    item-value="val"
                    v-model="limit"
                    @change="fetchData"
                    background-color="var(--g)"
                    dark
                    flat
                    solo
                  ></v-select>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="d-flex justify-end">
                <v-pagination
                  v-model="page"
                  color="#006341"
                  @input="fetchData"
                  :length="last_page"
                ></v-pagination>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="pa-3">
          <dialog-up
            :d_up="d_up"
            @refetch="fetchData"
            @close="d_up = false"
            :inventory="inventory"
            :type="d_type"
            :title="d_title"
            :width="d_width"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TitlePage from "../../components/atom/titlePage.vue";
import DialogUp from "./dialogUp.vue";
export default {
  name: "listContactPerson",
  components: {
    TitlePage,
    DialogUp,
  },
  computed: {
    ...mapState({
      permissions: (state) => state.permissions,
      role: (state) => state.role,
    }),
  },
  data() {
    return {
      loading: false,
      dataSet: null,
      page: 1,
      limit: 10,
      total: null,
      last_page: null,
      find: "",
      rows: [5, 10, 50, 100],
      storage_id: [],
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id",
        },
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: "Email",
          align: "start",
          sortable: false,
          value: "email",
        },
        {
          text: "Phone Number",
          align: "start",
          sortable: false,
          value: "phone_number",
        },
        {
          text: "Position",
          align: "start",
          sortable: false,
          value: "position",
        },
        {
          text: "City",
          align: "start",
          sortable: false,
          value: "city_text",
        },
        { text: "ACTION", sortable: false, value: "actions" },
      ],
      d_up: false,
      inventory: null,
      d_type: "",
      d_title: "",
      d_width: "450px",
      form: [
        {
          label: "Name",
          type: "text",
          key: "name",
        },
        {
          label: "Email",
          type: "text",
          key: "email",
        },
        {
          label: "Phone Number",
          type: "text",
          key: "phone_number",
        },
        {
          label: "Position",
          type: "text",
          key: "position",
        },
        {
          label: "Province",
          type: "select",
          key: "province",
        },
        {
          label: "City",
          type: "select",
          key: "city",
        },

        {
          label: "Address",
          type: "textarea",
          key: "address",
        },
      ],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `univ-partner/contact?filter[name]=${this.find}&include=dataSector&page[number]=${this.page}&page[size]=${this.limit}&filter[university_partnerships_id]=${this.$route.params.id}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },

    createData() {
      this.inventory = {
        body: {
          university_partnerships_id: this.$route.params.id,
          name: "",
          email: "",
          phone_number: null,
          province: null,
          city: null,
          address: "",
        },
        form: this.form,
        path: "univ-partner/contact/create",
      };
      this.d_title = "Add Contact Person";
      this.d_type = "up_cp";
      this.d_width = "450px";
      this.d_up = true;
    },
    updateData(item) {
      this.inventory = {
        body: {
          id: item.id,
          university_partnerships_id: item.university_partnerships_id,
          name: item.name,
          email: item.email,
          phone_number: item.phone_number,
          position: item.position,
          province: item.province,
          city: item.city,
          address: item.address,
        },
        form: this.form,
        path: "univ-partner/contact/create",
      };

      this.d_title = "Update Contact Person";
      this.d_type = "up_cp";
      this.d_width = "450px";
      this.d_up = true;
    },
    deleteData(item) {
      this.inventory = item;
      this.inventory["path"] = "univ-partner/contact/delete";
      this.d_title = "Delete Institution";
      this.d_type = "del_up";
      this.d_width = "300px";
      this.d_up = true;
    },
  },
};
</script>

<style scoped>
.input_green {
  border: 2px solid var(--g);
  border-radius: 5px;
  padding: 0 0 0 30px;
  height: 38px;
  background: #fff;
  width: 100%;
}
.input_green:focus {
  outline: none;
}
.magnify {
  margin-right: -30px;
}
</style>
